import { z } from "zod";
import { asTemplateId, asTripId, asUserId, ok } from "@pack-it-up/shared";
import { RoleSchema, firestoreTimestamp, parseDto, toTimestamp } from "./common.js";
const resourceRefToDomain = (kind, id) => kind === "trip" ? { kind: "trip", id: asTripId(id) } : { kind: "template", id: asTemplateId(id) };
// --- pending email invite (resource stored as an object) ---
export const PendingInviteDtoSchema = z.object({
    id: z.string(),
    email: z.string(),
    resource: z.object({ kind: z.enum(["trip", "template"]), id: z.string() }),
    role: RoleSchema,
    invitedBy: z.string(),
    status: z.enum(["pending", "claimed", "declined", "revoked"]),
    createdAt: firestoreTimestamp(),
});
export const toDomainPendingInvite = (raw) => {
    const p = parseDto(PendingInviteDtoSchema, raw, "PendingInvite");
    if (!p.ok)
        return p;
    const d = p.value;
    return ok({
        id: d.id,
        email: d.email,
        resource: resourceRefToDomain(d.resource.kind, d.resource.id),
        role: d.role,
        invitedBy: asUserId(d.invitedBy),
        status: d.status,
        createdAt: d.createdAt,
    });
};
export const toPendingInviteDto = (i) => ({
    id: i.id,
    email: i.email,
    resource: { kind: i.resource.kind, id: i.resource.id },
    role: i.role,
    invitedBy: i.invitedBy,
    status: i.status,
    createdAt: toTimestamp(i.createdAt),
});
// --- invite link (resource stored flat: resourceType + resourceId) ---
export const InviteLinkDtoSchema = z.object({
    token: z.string(),
    resourceType: z.enum(["trip", "template"]),
    resourceId: z.string(),
    role: RoleSchema,
    allowJoin: z.boolean(),
    createdBy: z.string(),
    revoked: z.boolean(),
    expiresAt: firestoreTimestamp().optional(),
    createdAt: firestoreTimestamp(),
});
export const toDomainInviteLink = (raw) => {
    const p = parseDto(InviteLinkDtoSchema, raw, "InviteLink");
    if (!p.ok)
        return p;
    const d = p.value;
    return ok({
        token: d.token,
        resource: resourceRefToDomain(d.resourceType, d.resourceId),
        role: d.role,
        allowJoin: d.allowJoin,
        createdBy: asUserId(d.createdBy),
        revoked: d.revoked,
        ...(d.expiresAt !== undefined ? { expiresAt: d.expiresAt } : {}),
        createdAt: d.createdAt,
    });
};
export const toInviteLinkDto = (l) => ({
    token: l.token,
    resourceType: l.resource.kind,
    resourceId: l.resource.id,
    role: l.role,
    allowJoin: l.allowJoin,
    createdBy: l.createdBy,
    revoked: l.revoked,
    ...(l.expiresAt !== undefined ? { expiresAt: toTimestamp(l.expiresAt) } : {}),
    createdAt: toTimestamp(l.createdAt),
});
//# sourceMappingURL=sharing.mapper.js.map